<!--
 * @Author: DQL
 * @Date: 2020-08-19 11:59:57
 * @LastEditors: LSG
 * @LastEditTime: 2021-05-06 16:09:07
 * @Description: file content
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-90 o-dialog--xl-60 page-addAdmini"
    title="新增管理员"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div
      class="dev-admin-selection"
    >
      <el-form
        ref="dlParams"
        class="c-form u-mg-b-8"
        :model="dlParams"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="管理员级别"
            >
              <span
                class="c-form__read"
              >
                {{ dlParams.adminLevelName || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
            >
              <hm-tree-select
                v-model="currentDeptCode"
                class="c-tree-select-wrap"
                instance-id="cTreeSelect"
                placeholder="请选择组织"
                :append-to-body="true"
                :options="selectTreeOptions"
                :normalizer="normalizer"
                :clearable="false"
                @input="getDeptUsers"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- table的ref的命名根据业务名称修改 -->
      <el-table
        ref="listTable"
        class="o-header-text-center"
        height="330px"
        stripe
        border
        highlight-current-row
        tooltip-effect="dark"
        :data="currentDeptUserList"
        :class="{ 'o-table-empty-center': currentDeptUserList.length <= 0 }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="30"
          align="center"
        />
        <el-table-column
          prop="capacityCode"
          label="身份编码"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="capacityName"
          label="身份名称"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="userCode"
          label="用户编码"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column
          prop="userName"
          label="用户名称"
          min-width="140"
          show-overflow-tooltip
        />
      </el-table>
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        :disabled="multipleSelectedRow.length<=0"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { adminLevelManageService } from './adminLevelManage.service.js';
export default {
  name: 'AddDialog',
  props: {
    dlParams: {
      type: Object,
      required: true,
      default () {
        return {
          parentMenuCode: null,
          parentMenuName: null
        };
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态

      dialogShow: true, // 模态框dialog显示

      selectTreeOptions: [], // 下拉树数据

      currentDeptCode: null, // 当前机构部门

      currentDeptUserList: [], // 当前机构部门的用户列表（不是管理员）

      multipleSelectedRow: [] // 表格选中行（多选）
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      if (node.childNodes == null || node.childNodes.length === 0) {
        return {
          id: node.nodeCode,
          label: node.nodeName
        };
      }
      return {
        id: node.nodeCode,
        label: node.nodeName,
        children: node.childNodes
      };
    },
    /**
     * @description: 获取机构树
     * @param {*}
     * @return {*}
     */
    getDeptTree () {
      adminLevelManageService.getDeptTree()
        .then(rsp => {
          this.selectTreeOptions = rsp.data;
          if (rsp.data && rsp.data.length > 0) {
            this.currentDeptCode = rsp.data[0].nodeCode;
          }
        })
        .catch(err => {
          console.error('获取机构树错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 树组件选中节点，获取节点信息信息以及节点路径
     * @param {*}
     * @return {*}
     */
    handleNodeClick (data, node) {
      this.currentDeptCode = data.nodeCode;
      // 获取选中节点的用户列表
      this.getDeptUsers();
    },
    /**
     * @description: 获取机构树下的用户列表
     * @param {*}
     * @return {*}
     */
    getDeptUsers () {
      adminLevelManageService.getDeptUsers(this.currentDeptCode)
        .then(rsp => {
          this.currentDeptUserList = rsp.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.loading = true;
      const addUserList = _this.multipleSelectedRow.map(_row => {
        return {
          adminLevel: _this.dlParams.adminLevel,
          capacityCode: _row.capacityCode
        };
      });
      adminLevelManageService.save(addUserList)
        .then(rsp => {
          _this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          _this.$emit('closeDialog', '');
          _this.$emit('callback');
        })
        .catch(err => {
          console.error('管理员新增出错！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    }
  },
  created () {
    this.getDeptTree();
  }
};
</script>

<style lang="scss">
.page-addAdmini{
  .dev-admin-selection{
    height: 400px;

    .l-flex__item{
      width: 40%;
    }
  }
}
</style>
